/**
 * RatingRegisterPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  InputFormTable,
  Text,
  ModalLayout,
} from 'components';
import { Input, Button, Radio, Flex, InputNumber, Table, Tag } from 'antd';
import { MinusOutlined } from '@ant-design/icons';

const COUPON_TYPE = {
  ALL: {
    label: '전체할인',
    color: 'default',
  },
  PRODUCT: {
    label: '상품할인',
    color: 'default',
  },
  MENU: {
    label: '메뉴할인',
    color: 'default',
  },
  DESSERT: {
    label: '디저트할인',
    color: 'default',
  },
  MD: {
    label: 'MD할인',
    color: 'default',
  },
  FREQUENCY: {
    label: '프리퀀시',
    color: 'default',
  },
};

const VOUCHER_TYPE = {
  AMOUNT_DISCOUNT: {
    label: '금액할인권',
    color: 'default',
  },
  PERCENT_DISCOUNT: {
    label: '% 할인권',
    color: 'default',
  },
  EXCHANGE: {
    label: '교환권',
    color: 'default',
  },
};

const RatingRegisterPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    type,
    inputValue,
    onChange,
    coupons,
    onSelect,
    selectedList,
    onSelectedList,
    onSubmit,
    onSuccess,
    isOpened,
    setIsOpened,
  } = props;

  /* ===== STATE ===== */

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form1 = [
    {
      label: '등급명',
      required: true,
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="등급명 입력"
                style={{ width: 400 }}
                value={inputValue?.grade_name}
                onChange={(e) => onChange('grade_name', e.target.value)}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '변경 사유',
      required: true,
      message: '고객에게 표시될 등급변경 사유입니다.',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="등급변경 사유 입력"
                style={{ width: 400 }}
                value={inputValue?.grade_reason}
                onChange={(e) => onChange('grade_reason', e.target.value)}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '등급 설명',
      required: true,
      form: [
        {
          input: (
            <Flex gap={8} vertical>
              <Flex flex={1} gap={8} align="center">
                <Text size={14} style={{ minWidth: 50 }}>
                  기준
                </Text>
                <Input
                  size="large"
                  placeholder="등급설명 입력"
                  style={{ width: 500 }}
                  value={inputValue?.grade_description?.['기준']}
                  onChange={(e) =>
                    onChange('grade_description', {
                      ...inputValue['grade_description'],
                      기준: e.target.value,
                    })
                  }
                />
              </Flex>

              <Flex flex={1} gap={8} align="center">
                <Text size={14} style={{ minWidth: 50 }}>
                  설명
                </Text>
                <Input
                  size="large"
                  placeholder="등급설명 입력"
                  style={{ width: 500 }}
                  value={inputValue?.grade_description?.['설명']}
                  onChange={(e) =>
                    onChange('grade_description', {
                      ...inputValue['grade_description'],
                      설명: e.target.value,
                    })
                  }
                />
              </Flex>
            </Flex>
          ),
        },
      ],
    },
    {
      label: '등급 조건',
      required: true,
      direction: 'column',
      form: [
        {
          input: (
            <>
              <p>구매 금액</p>
              <InputNumber
                size="large"
                placeholder="0"
                style={{ ...styles.form.input.large }}
                value={inputValue?.grade_condition_amount}
                onChange={(e) => onChange('grade_condition_amount', e)}
                min={0}
              />
              <p>원 이상</p>
            </>
          ),
        },
        {
          input: (
            <>
              <p>구매 횟수</p>
              <InputNumber
                size="large"
                placeholder="0"
                style={{ ...styles.form.input.large }}
                value={inputValue?.transaction_count}
                onChange={(e) => onChange('transaction_count', e)}
                min={0}
              />
              <p>건 이상</p>
            </>
          ),
        },
      ],
    },
    {
      label: '사용여부',
      required: true,
      form: [
        {
          input: (
            <Radio.Group
              value={inputValue?.is_enable}
              onChange={(e) => onChange('is_enable', e.target.value)}
            >
              <Radio value={'Y'}>사용함</Radio>
              <Radio value={'N'}>사용안함</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '고정여부',
      required: true,
      form: [
        {
          input: (
            <Radio.Group
              value={inputValue?.is_fixed}
              onChange={(e) => onChange('is_fixed', e.target.value)}
            >
              <Radio value={'Y'}>고정등급</Radio>
              <Radio value={'N'}>변동등급</Radio>
            </Radio.Group>
          ),
        },
      ],
    },

    {
      label: '쿠폰 혜택 적용',
      form: [
        {
          input: (
            <Flex vertical gap={10}>
              <Button
                size="large"
                onClick={() => setIsOpened(!isOpened)}
                style={{ width: 100 }}
              >
                쿠폰조회
              </Button>

              {inputValue?.couponList?.map((coupon, index) => (
                <Flex
                  key={`coupon-${coupon.key ?? coupon.coupon_id}`}
                  justify="space-between"
                  align="center"
                  flex={1}
                >
                  <Flex gap={20} align="center">
                    <Text size={14} weight={700} style={{ flex: 1 }}>
                      {coupon.coupon_name || '삭재된 쿠폰'}
                    </Text>

                    <InputNumber
                      value={coupon.num}
                      onChange={(e) => {
                        const newList = inputValue?.couponList?.map(
                          (selectCoupon, selectIndex) => ({
                            ...selectCoupon,
                            ...(index === selectIndex && { num: e }),
                          })
                        );
                        const newSelectedList = selectedList?.map((s, i) => {
                          if (s.coupon_id === coupon.coupon_id) {
                            s.num = e;
                          }
                          return s;
                        });
                        onSelectedList(newSelectedList);
                        onChange('couponList', newList);
                      }}
                      suffix={'개'}
                      min={1}
                      max={5}
                    />
                  </Flex>

                  <Button
                    danger
                    size="small"
                    onClick={() => {
                      const removeList = [
                        ...inputValue?.couponList.slice(0, index),
                        ...inputValue?.couponList.slice(index + 1),
                      ];
                      onSelect('ALL-CHECKED', removeList);
                      onChange('couponList', removeList);
                    }}
                  >
                    <MinusOutlined />
                  </Button>
                </Flex>
              ))}
            </Flex>
          ),
          fullscreen: true,
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <React.Fragment>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            {/* 기본정보 */}
            <Content maxWidth={'100%'} padding={'20px 0px'} borderRadius={4}>
              <InputFormTable form={form1} />
            </Content>
            {/* 기본정보 끝 */}

            {/* 버튼 */}
            <Content maxWidth={'100%'} backgroundColor={'none'}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  size="large"
                  style={{
                    ...styles.button,
                    background: 'var(--primary-color)',
                    color: '#FFFFFF',
                  }}
                  onClick={() => onSubmit(type)}
                >
                  저장
                </Button>
                <Button
                  size="large"
                  style={{ ...styles.button }}
                  onClick={onSuccess}
                >
                  취소
                </Button>
              </div>
            </Content>
            {/* 버튼 끝 */}
          </Col>
        </Row>
      </Content>

      {/* SECTION - 쿠폰 선택 모달 */}
      <ModalLayout
        open={isOpened}
        onCancel={() => {
          onSelect('CANCEL');
          setIsOpened(!isOpened);
        }}
        footer={
          <Flex gap={4} justify="flex-end" align="center">
            <Button
              onClick={() => {
                onSelect('CANCEL');
                setIsOpened(!isOpened);
              }}
            >
              닫기
            </Button>
            <Button
              type="primary"
              onClick={() => {
                onSelect('CONFIRM');
                setIsOpened(!isOpened);
              }}
            >
              확인
            </Button>
          </Flex>
        }
      >
        <Content maxWidth={'100%'}>
          <Row>
            <Col x={24}>
              <Table
                dataSource={coupons}
                columns={[
                  {
                    key: 'coupon_name',
                    title: '쿠폰명',
                    dataIndex: 'coupon_name',
                  },
                  {
                    key: 'coupon_type',
                    title: '쿠폰타입',
                    dataIndex: 'coupon_type',
                    render: (item) => (
                      <Tag color={COUPON_TYPE[item]?.color}>
                        {COUPON_TYPE[item]?.label}
                      </Tag>
                    ),
                  },
                  {
                    key: 'voucher_type',
                    title: '쿠폰타입',
                    dataIndex: 'voucher_type',
                    render: (item) => (
                      <Tag color={VOUCHER_TYPE[item]?.color}>
                        {VOUCHER_TYPE[item]?.label}
                      </Tag>
                    ),
                  },
                  {
                    key: 'discount_price',
                    title: '쿠폰명',
                    dataIndex: 'coupon_name',
                  },
                ]}
                rowSelection={{
                  type: 'checkbox',
                  onSelect: (record, selected) =>
                    onSelect(selected ? 'checked' : 'unchecked', record),
                  onSelectAll: (selected, selectedRows) =>
                    onSelect(
                      selected ? 'all-checked' : 'all-unchecked',
                      selectedRows
                    ),
                  selectedRowKeys: selectedList?.map((coupon) => coupon?.key),
                }}
              />
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </React.Fragment>
  );
};

export default RatingRegisterPresenter;
